/* eslint-disable no-undef */
import React, { useState, useEffect, useRef } from 'react';
import Loader from '../Common/Loader';
import { Typeahead } from 'react-bootstrap-typeahead';
import constants from '../../constants';
import { useParams, useNavigate } from 'react-router-dom';
// import { history } from '../../redux/store';
import axios from 'axios';
import { cookieStorageUtility } from '../../utils/utilityFunctions';
const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const AddUser = (props) => {
  const navigate = useNavigate();
  const [detail, setDetail] = useState({
    userId: '',
    firstName: '',
    lastName: '',
    mobile: '',
    email: '',
    roles: [],
    roles_users: []
  });
  const { id } = useParams();
  const [hotelList, setHotelList] = useState([]);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [showUILoader, setShowUILoader] = useState(false);
  const typeHead = useRef();

  useEffect(() => {
    if (typeof id !== 'undefined' && id !== '') {
      getUserDetail(id);
    }
    // eslint-disable-next-line
  }, []);

  const handelChangeValue = (e, type) => {
    let newDetail = { ...detail };
    newDetail[type] = e.target.value;
    setDetail(newDetail);
  };

  const showMessage = (type, msg) => {
    setFlag(true);
    setType(type);
    setMessage(msg);
    setTimeout(() => setFlag(false), 5000);
  };

  const addUser = () => {
    if (validateParam()) {
      setShowUILoader(false);
      axios(serverUrl + 'user/createUser', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        data: detail
      })
        .then(response => {
          if (response.data.status === 'success') {
            showMessage('success', response.data.message);
            setTimeout(() => {
              window.open(serverUrl + 'user/index', '_self');
            }, 2000);
          } else {
            showMessage('error', response.data.message);
          }
          setShowUILoader(false);
        })
        .catch(error => {
          console.log(error);
          setShowUILoader(false);
        });
    }
  };

  const getUserDetail = (id) => {
    setShowUILoader(false);
    axios(serverUrl + 'users/userDetail', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { userId: id }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setDetail(response.data.data);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const cancelUser = () => {
    navigate('/users');  
  };

  const updateUser = () => {
    if (detail.roles_users.length === 0) {
      showMessage('error', 'Please select role');
    } else {
      setShowUILoader(true);
      let setData = { ...detail };
      axios(serverUrl + 'users/updateUser', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: setData
      }).then(response => {
        if (response.data.status === 'success') {
          showMessage('success', response.data.message);
          setTimeout(() => {
            navigate('/users');
          },500);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      }).catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
    }
  };

  // ...existing code for getHotelList, handleSearch, paramChange, etc. if needed...

  return (
    <React.Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu"> User</div>
          </div>
        </div>
      </div>
      {flag ? (
        <div
          className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}
        >
          {message}
        </div>
      ) : ''}
      <div className="container">
        <div className="container_fluid pad_lft_rht20 padtop25 text-start">
          <div className="cover">
            <div className="ovr marg_bottom15 bld fnt16">Basic Details</div>
            <div className="row">
              <div className="col-xs-12 col-sm-6 marg_bottom15">
                <div className="ovr marg_bottom5">
                  First Name <span className="color5">*</span>
                </div>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={detail.firstName}
                    onChange={e => handelChangeValue(e, 'firstName')}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-sm-6 marg_bottom15">
                <div className="ovr marg_bottom5">
                  Last Name <span className="color5"></span>
                </div>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={detail.lastName}
                    onChange={e => handelChangeValue(e, 'lastName')}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-sm-6 marg_bottom15">
                <div className="ovr marg_bottom5">Email</div>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={detail.email}
                    onChange={e => handelChangeValue(e, 'email')}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-sm-6 marg_bottom15">
                <div className="ovr marg_bottom5">
                  Roles <span className="color5">*</span>
                </div>
                <div className="frm border_all_1 border_color_1">
                  <Typeahead
                    selected={detail.roles_users}
                    id="public-methods-example"
                    labelKey="name"
                    multiple={false}
                    options={detail.roles}
                    placeholder="Choose roles..."
                    onChange={selected => {
                      setDetail(prev => ({ ...prev, roles_users: selected }));
                    }}
                  />
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-xs-12 col-md-1" >
                  <input
                    value="Save"
                    className="btn1 pad_top_bot7 pad_lft_rht20 fnt14 cursor_p"
                    type="button"
                    onClick={updateUser}
                  />
                </div>
                <div className="col-xs-12 col-md-6" >
                  <input
                    value="Cancel"
                    className="btn1 pad_top_bot7 pad_lft_rht20 fnt14 cursor_p"
                    type="button"
                    onClick={cancelUser}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddUser;

